import {
	Airplay,
	ALargeSmall,
	Apple,
	Archive,
	ArchiveRestore,
	ArrowDownAZ,
	ArrowDownToLine,
	ArrowLeftFromLine,
	ArrowRight,
	ArrowRightFromLine,
	ArrowUpDown,
	ArrowUpZA,
	Asterisk,
	Bold,
	BookMarked,
	BookOpenText,
	BookText,
	Bot,
	BrushCleaning,
	Bug,
	Building2,
	CalendarDays,
	Camera,
	ChartColumn,
	ChartLine,
	Check,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronsDownUp,
	ChevronsUpDown,
	ChevronUp,
	Circle,
	CircleAlert,
	CircleArrowDown,
	CircleArrowLeft,
	CircleArrowRight,
	CircleArrowUp,
	CircleCheck,
	CircleDashed,
	CircleEllipsis,
	CirclePause,
	CirclePlay,
	CircleQuestionMark,
	CircleUser,
	CircleX,
	Clock,
	Code,
	Copy,
	CornerDownLeft,
	CornerDownRight,
	Download,
	Droplet,
	Ellipsis,
	Eraser,
	Eye,
	EyeOff,
	File,
	FileDown,
	FileText,
	FolderInput,
	FolderOpen,
	FolderOutput,
	Funnel,
	GitCompareArrows,
	Globe,
	Grid2x2,
	GripVertical,
	HatGlasses,
	Heading1,
	Heading2,
	Heading3,
	Heading4,
	Heading5,
	Heading6,
	Highlighter,
	History,
	House,
	Image,
	Info,
	Italic,
	KeyRound,
	LayoutDashboard,
	Link,
	List,
	ListChevronsDownUp,
	ListChevronsUpDown,
	ListIndentDecrease,
	ListIndentIncrease,
	ListOrdered,
	ListTree,
	LoaderCircle,
	LogIn,
	LogOut,
	Mail,
	Menu,
	MessageCircle,
	Minus,
	Moon,
	Paintbrush,
	PaintRoller,
	Palette,
	PanelLeftDashed,
	PanelTopDashed,
	Paperclip,
	Pencil,
	Phone,
	Pilcrow,
	Plus,
	QrCode,
	Redo,
	RefreshCw,
	RemoveFormatting,
	Reply,
	RotateCcw,
	Rss,
	Save,
	Search,
	SearchX,
	Send,
	SeparatorHorizontal,
	Settings,
	Settings2,
	ShieldUser,
	ShoppingBasket,
	Shuffle,
	Square,
	SquareCheck,
	SquareCheckBig,
	SquareDashed,
	SquareScissors,
	StepBack,
	Strikethrough,
	Subscript,
	Sun,
	SunMoon,
	Superscript,
	Table,
	TableCellsSplit,
	TableOfContents,
	TableProperties,
	TextAlignCenter,
	TextAlignEnd,
	TextAlignJustify,
	TextAlignStart,
	TextQuote,
	Trash2,
	TriangleAlert,
	Type,
	Underline,
	Undo,
	Unlink,
	Upload,
	User,
	Users,
	X,
	ZoomIn,
	ZoomOut,
} from '@lucide/vue'

const library = {
	ALargeSmall,
	Airplay,
	Apple,
	Archive,
	ArchiveRestore,
	ArrowDownAZ,
	ArrowDownToLine,
	ArrowLeftFromLine,
	ArrowRight,
	ArrowRightFromLine,
	ArrowUpDown,
	ArrowUpZA,
	Asterisk,
	Bold,
	BookMarked,
	BookOpenText,
	BookText,
	Bot,
	BrushCleaning,
	Bug,
	Building2,
	CalendarDays,
	Camera,
	ChartColumn,
	ChartLine,
	Check,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	ChevronsDownUp,
	ChevronsUpDown,
	Circle,
	CircleAlert,
	CircleArrowDown,
	CircleArrowLeft,
	CircleArrowRight,
	CircleArrowUp,
	CircleCheck,
	CircleDashed,
	CircleEllipsis,
	CirclePause,
	CirclePlay,
	CircleQuestionMark,
	CircleUser,
	CircleX,
	Clock,
	Code,
	Copy,
	CornerDownLeft,
	CornerDownRight,
	Download,
	Droplet,
	Ellipsis,
	Eraser,
	Eye,
	EyeOff,
	File,
	FileDown,
	FileText,
	FolderInput,
	FolderOpen,
	FolderOutput,
	Funnel,
	GitCompareArrows,
	Globe,
	Grid2x2,
	GripVertical,
	HatGlasses,
	Heading1,
	Heading2,
	Heading3,
	Heading4,
	Heading5,
	Heading6,
	Highlighter,
	History,
	House,
	Image,
	Info,
	Italic,
	KeyRound,
	LayoutDashboard,
	Link,
	List,
	ListChevronsDownUp,
	ListChevronsUpDown,
	ListIndentDecrease,
	ListIndentIncrease,
	ListOrdered,
	ListTree,
	LoaderCircle,
	LogIn,
	LogOut,
	Mail,
	Menu,
	MessageCircle,
	Minus,
	Moon,
	PaintRoller,
	Paintbrush,
	Palette,
	PanelLeftDashed,
	PanelTopDashed,
	Paperclip,
	Pencil,
	Phone,
	Pilcrow,
	Plus,
	QrCode,
	Redo,
	RefreshCw,
	RemoveFormatting,
	Reply,
	RotateCcw,
	Rss,
	Save,
	Search,
	SearchX,
	Send,
	SeparatorHorizontal,
	Settings,
	Settings2,
	ShieldUser,
	ShoppingBasket,
	Shuffle,
	Square,
	SquareCheck,
	SquareCheckBig,
	SquareDashed,
	SquareScissors,
	StepBack,
	Strikethrough,
	Subscript,
	Sun,
	SunMoon,
	Superscript,
	Table,
	TableCellsSplit,
	TableOfContents,
	TableProperties,
	TextAlignCenter,
	TextAlignEnd,
	TextAlignJustify,
	TextAlignStart,
	TextQuote,
	Trash2,
	TriangleAlert,
	Type,
	Underline,
	Undo,
	Unlink,
	Upload,
	User,
	Users,
	X,
	ZoomIn,
	ZoomOut,
}

const iconNames = Object.keys(library)

export { library, iconNames }
